export default "__VITE_ASSET__72ebb775__"